<template>
  <div v-loading="loading" class="page-form page-base">
    <h3 class="title">高端总经销生产计划</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <form-button v-if="mode === 'edit'" @click="$router.go(-1)">返回</form-button>
        <form-button v-if="buttons.new" name="新建" @click="newCreate" />
        <form-button v-if="buttons.save" type="primary" name="保存" @click="saveData('SAVE')" />
        <form-button v-if="buttons.submit" icon="form-advance" name="提交" @click="saveData('SUBMIT')" />
        <form-button v-if="buttons.edit" name="编辑" @click="formDis = false" />
        <form-button v-if="buttons.approve" name="审批通过" @click="saveData('APPROVE')" />
        <form-button v-if="buttons.reject" name="审核拒绝" @click="saveData('REJECT')" />
        <form-button v-if="buttons.order" name="后续订单" @click="followOrder" />
        <form-button v-if="buttons.cancel" name="取消" @click="saveData('CANCEL')" />
        <form-button v-if="buttons.revoke" name="撤回" @click="saveData('REVOKE')" />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        :disabled="isEdit"
        label-width="100px"
        :model="conditions"
        :rules="rules"
        :show-message="false"
      >
        <common-title title="基本信息" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="生产计划编号">
              <el-input v-model="conditions.prodpl_id" disabled placeholder="" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="prodpl_type" label="单据类型">
              <el-input value="高端总经销生产计划" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="sold_to" label="订单客户">
              <wly-input v-model="conditions.sold_to" :disabled="role.ROLE === 'WLY001'" input-type="customer" @enter="handleEnter" @handleSuffixClick="openDialog($event, '客户选择')" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="name_soldto" label="订单客户名称">
              <el-input v-model="conditions.name_soldto" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="开票客户">
              <el-input v-model="conditions.name_billto" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="客户类型">
              <el-select v-model="conditions.soldto_type" placeholder="" disabled>
                <el-option
                  v-for="item in selectDataOptions['A0009']"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="contactor" label="联系方式">
              <el-input v-model="conditions.contactor" clearable />
            </el-form-item>
          </el-col>

          <el-col :lg="8" :md="12">
            <el-form-item prop="sals_center" label="营销单元">
              <el-select v-model="conditions.sals_center" placeholder="" :disabled="selectDataOptions.orgList && selectDataOptions.orgList.length === 1" clearable>
                <el-option
                  v-for="item in selectDataOptions['orgList']"
                  :key="item.zzfld00001h"
                  :label="item.mc_short"
                  :value="item.zzfld00001h"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="预约">
              <el-checkbox v-model="conditions.preorder" true-label="1" false-label="0" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="huokuan" label="所需货款(元)">
              <el-input v-model="conditions.huokuan" disabled clearable />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="confrm" label="货款确认">
              <el-checkbox v-model="conditions.confrm" disabled true-label="X" false-label="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="地址" prop="address">
              <el-input
                v-model="conditions.address"
                type="textarea"
                rows="2"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                type="textarea"
                rows="2"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col v-if="conditions.stacode === 'E006'" :lg="8" :md="12">
            <el-form-item label="审核意见">
              <el-input
                v-model="conditions.audit_opinion"
                type="textarea"
                rows="2"
                disabled
              />
            </el-form-item>
          </el-col>
        </el-row>
        <common-title title="状态" />
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item label="制单人">
              <el-input v-model="conditions.uname" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="部门">
              <el-input v-model="conditions.dept_name" disabled />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="创建日期">
              <el-date-picker
                v-model="conditions.datum"
                type="date"
                value-format="yyyyMMdd"
                disabled
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item label="状态">
              <el-input v-model="conditions.status" disabled />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="生产计划单项目" :custome-config="() => vxeShowCustom('xTable')">
        <template v-if="!isEdit" #button>
          <table-button name="add" tip="新增" @click="insertData" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :cell-class-name="cellClassName"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'medium' }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #prod_id="{ row }">
            <wly-input
              v-model="row.prod_id"
              size="mini"
              :disabled="isEdit"
              placeholder=""
              input-type="product"
              :query-params="{ customerCode: conditions.sold_to, mode: 'SC' }"
              @enter="handleEnter(...arguments,row)"
              @handleSuffixClick="openDialog($event, '产品选择', row)"
            />
          </template>
          <template #planqty_bottle="{ row }">
            <el-input
              v-model.number="row.planqty_bottle"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="changeInput(row)"
            />
          </template>
          <template #planqty_box="{ row }">
            <el-input
              v-model.number="row.planqty_box"
              :disabled="isEdit"
              size="mini"
              @keyup.enter.native="changeInput(row)"
            />
          </template>
          <template #area="{ row }">
            <el-input v-model="row.area" :disabled="isEdit" size="mini" />
          </template>
          <template #abclv="{ row }">
            <el-select v-model="row.abclv" :disabled="isEdit" placeholder="" size="mini">
              <el-option value="" label="" />
              <el-option
                v-for="selectItem in selectDataOptions['level']"
                :key="selectItem.value"
                :label="selectItem.name"
                :value="selectItem.value"
              />
            </el-select>
          </template>
          <template #remark="{row}">
            <el-input v-model="row.remark" :disabled="isEdit" size="mini" />
          </template>
          <template #operation="{row}">
            <div class="operation" @click="openDialog($event, '组件列表', row)">
              查看
            </div>
          </template>
          <template #versions="{row}">
            <el-select
              v-model="row.version"
              placeholder=""
              type="select"
              clearable
              size="mini"
              class="standard"
              :disabled="isEdit"
              @change="changeVersion($event,row.versions,row)"
            >
             <el-option
                v-for="item in row.versions"
                :key="item.version"
                :label="item.version"
                :value="item.version"
              />
            </el-select>
          </template>
          <!-- <template #f_date="{row}">
            <el-date-picker
              v-model="row.f_date"
              type="date"
              value-format="yyyyMMdd"
              size="mini"
            />
          </template> -->
        </vxe-grid>
      </TableCommon>

      <TableCommon title="附件" :custome-config="() => vxeShowCustom('fileTable')">
        <template v-if="!isEdit" #button>
          <el-upload
            ref="upload"
            accept=".png,.pdf,.jpg"
            action=""
            :on-change="uploadFile"
            :show-file-list="false"
            :auto-upload="false"
          >
            <table-button slot="trigger" name="upload" tip="上传" />
          </el-upload>
          <table-button name="delete" tip="删除" @click="delUpload" />
        </template>
        <vxe-grid
          ref="fileTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsFile.columns"
          :data="gridOptionsFile.data"
        >
          <template #filename="{ row }">
            <span class="blue" @click="downLoadFile(row)">{{ row.filename }}</span>
          </template>
        </vxe-grid>
      </TableCommon>

      <TableCommon title="状态变更记录" :custome-config="() => vxeShowCustom('history')">
        <vxe-grid
          ref="history"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="240"
          max-height="500"
          align="center"
          size="mini"
          :empty-render="{ name: 'NotData' }"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :edit-config="{ trigger: 'manual', mode: 'row' }"
          :columns="gridOptionsHistory.columns"
          :data="gridOptionsHistory.data"
        />
      </TableCommon>
    </div>

    <!-- 选择通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="dialogTitle === '客户选择'">
        <client-select ref="ClientSelect" />
      </template>
      <template v-if="dialogTitle === '产品选择'">
        <product-select ref="ProductSelect" :is-auth="true" :query-params="{ customerCode: conditions.sold_to, mode: 'GD' }" />
      </template>
      <template v-if="dialogTitle === '组件列表'">
        <ComponentList ref="comList" :rowDetail="componentRowDetail"/>
      </template>
      <div slot="footer">
        <el-button
          type="default"
          size="small"
          icon="el-icon-circle-close"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-check"
          @click="submitHandle"
        >确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ClientSelect from '@/components/dialog/ClientSelect.vue'
import ProductSelect from '@/components/dialog/ProductSelect.vue'
import eventBus from '@/utils/eventBus'
import { apiGetProdDetail, apiHandleProdItem, apiHandleProdFollowOrder, apiHandleProdRevocation, apiHandleProdSave, apiHandleProdSub } from '@/api/sap/make-plan'
import { formatSapFileSize } from '@/mixins/index'
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiSapSingleClientInfo } from '@/api/common'
import { mapGetters } from 'vuex'
import { sapDownloadFile } from '@/utils/frontExport'
const ComponentList = () => import('@/components/dialog/componentList.vue')
let prodpl_item = 0
export default {
  components: { ClientSelect, ProductSelect,ComponentList },
  data() {
    const rules = {
      prodpl_type: [{ required: true, message: '请选择单据类型', trigger: 'change' }],
      sold_to: [{ required: true, message: '请选择订单客户', trigger: 'change' }],
      address: [{ required: true, message: '请输入地址信息！', trigger: 'blur' }]
    }
    return {
      componentRowDetail: {},
      mode: 'add',
      rules,
      dialogTitle: '客户选择',
      showDialog: false,
      errorList: [],
      formDis: false,
      buttons: {
        approve: '',
        cancel: '',
        commit: '',
        edit: '',
        reject: '',
        revoke: '',
        save: 'X',
        submit: '',
        new: ''
      },
      conditions: {
        prodpl_id: '',
        prodpl_type: 'ZPD3',
        sold_to: '',
        name_soldto: '',
        bill_to: '',
        name_billto: '',
        contactor: '',
        address: '',
        preorder: '',
        soldto_type: '',
        sals_center: '',
        datum: '',
        uname: '',
        status: '新建',
        remark: '',
        dept_name: '',
        audit_opinion: ''
      },
      validRules: {
        prod_id: [{ required: true }],
        planqty_box: [{ required: true }]
      },
      selectDataOptions: {
        orgList: []
      },
      loading: false,
      gridOptions: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          {
            field: 'prodpl_item',
            title: '行号',
            width: 50,
            formatter: ({ cellValue }) => Number(cellValue)
          },
          {
            field: 'prod_id',
            title: '产品编号',
            width: 180,
            slots: { default: 'prod_id' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'description',
            title: '描述',
            width: 180
          },
          {
            field: 'wlybrand',
            title: '品牌',
            width: 180
          },
          {
            field: 'planqty_box',
            title: '数量（件）',
            width: 120,
            slots: { default: 'planqty_box' },
            editRender: {},
            params: { bgEdit: true }
          },
          {
            field: 'planqty_bottle',
            title: '数量（瓶）',
            width: 120,
            slots: { default: 'planqty_bottle' },
            params: { bgEdit: true }
          },
          {
            field: 'huokuan',
            title: '所需货款(元)',
            width: 180
          },
          {
            field: 'planqty_ton',
            title: '数量（吨）',
            width: 120
          },
          {
            field: 'area',
            title: '区域',
            width: 180,
            slots: { default: 'area' },
            params: { bgEdit: true }
          },
          {
            field: 'abclv',
            title: '优先级',
            width: 180,
            slots: { default: 'abclv' },
            params: { bgEdit: true }
          },
          {
            field: 'alv_box',
            title: '可用总量（件）',
            width: 180
          },
          {
            field: 'purmat_qty',
            title: '采购中数量（件）',
            width: 180
          },
          {
            field: 'pur_date',
            title: '采购到货日期',
            width: 180
          },
          { field: 'version', title: '版本号',width: 60, slots: { default: 'versions' }, params: { bgEdit: true }},
          { field: 'bom_code', title: 'BOM编码',width: 60,},
          { field: 'operation', title: '组件列表',width: 60, slots: { default: 'operation' }, params: { bgEdit: true }},
          {
            field: 'remark',
            title: '备注',
            width: 180,
            slots: { default: 'remark' },
            params: { bgEdit: true }
            // editRender: { name: 'input' }
          }
        ],
        data: []
      },
      gridOptionsFile: {
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 40 },
          { field: 'filename', title: '附件名', width: 'auto', slots: { default: 'filename' }},
          { field: 'doc_type', title: '附件类型', width: 'auto' },
          { field: 'filelength', title: '附件大小', width: 'auto', formatter: ({ cellValue }) => formatSapFileSize(cellValue) },
          { field: 'zzfld00002d', title: '上传人', width: 'auto' },
          { field: 'zzfld00002d_dscr', title: '上传人姓名', width: 'auto' },
          { field: 'created_date', title: '上传日期', width: 'auto' },
          { field: 'created_time', title: '上传时间', width: 'auto' }
        ],
        data: []
      },
      gridOptionsHistory: {
        columns: [
          { field: 'zzfld00000u', title: '操作人', width: 'auto' },
          { field: 'zzfld000031', title: '操作人姓名', width: 'auto' },
          { field: 'zzfld00000v_text', title: '状态', width: 'auto' },
          { field: 'zzfld00000w', title: '变更日期', width: 'auto' },
          { field: 'zzfld00000x', title: '变更时间', width: 'auto' },
          { field: 'zzfld000092', title: '拒绝原因', width: 'auto' }
        ],
        data: []
      },
      currentRow: {}
    }
  },
  computed: {
    isEdit() {
      if (this.conditions.status === '新建' || this.conditions.status === '已创建') {
        return this.formDis
      } else {
        return true
      }
    },
    ...mapGetters(['role', 'customerInfo', 'userInfo'])
  },
  created() {
    // 生产计划单据类型
    this.getSelectDictDataOrigin('A0006')
    // 客户类型
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0008')
    this.getSelectDictDataOrigin('level')
    if (this.$route.query.id) {
      this.mode = 'edit'
      // 请求合同详情
      this.queryData()
    } else {
      if (this.role.ROLE === 'WLY001') {
        const { info, address, high_yxdy } = this.customerInfo

        this.conditions.sold_to = info.partner
        this.conditions.name_soldto = info.name_org1
        this.conditions.soldto_type = info.zzfld000016
        this.conditions.bill_to = info.bill_to || info.partner
        this.conditions.name_billto = info.bill_to_name || info.name_org1
        high_yxdy && (this.conditions.sals_center = high_yxdy[0].zzfld00001h)
        const reladdress = address.find(v => v.adr_kind === 'SHIP_TO')
        this.conditions.contactor = reladdress.tel_number
        this.conditions.address = reladdress.street
        this.selectDataOptions['orgList'] = high_yxdy
      }
      this.conditions.dept_name = this.userInfo.deptName
      this.conditions.datum = this.$utilsCommon.parseTime(new Date().getTime(), '{y}{m}{d}')
      this.conditions.uname = this.role.login_user
    }
  },
  methods: {
    changeVersion(e,arg,row){
      let bomCode = null
      arg.forEach(ele => {
        if(ele.version === e){
          bomCode = ele.bom_code
        }
      });
      this.gridOptions.data.forEach((ele,idx) => {
        if(ele.prod_id === row.prod_id && ele.planqty_box === row.planqty_box){
          this.gridOptions.data[idx].bom_code = bomCode
        }
      });
    },
    cellClassName({ column }) {
      return column.params?.bgEdit ? 'cell--bg--edit' : 'cell--bg--default'
    },
    // 后续订单
    async followOrder() {
      const params = {
        user_bp: this.$store.getters.role.USER_BP,
        head: this.conditions,
        item: this.gridOptions.data
      }
      const { data, button } = await apiHandleProdFollowOrder(params)
      this.buttons = button
    },
    // 新建
    newCreate() {
      this.$router.replace('/wly/make-plan/order-edit')
      this.mode === 'edit' && eventBus.$emit('pageReload')
    },
    async queryData() {
      const { head, item, history, button } = await apiGetProdDetail({ prodpl_id: this.$route.query.id, user_bp: this.role.USER_BP })
      Object.assign(this.conditions, head)
      this.initCustome()
      this.gridOptions.data = item
      this.buttons = button
      this.gridOptionsHistory.data = history
      if (button.edit) {
        this.formDis = true
      }
    },
    // 文件下载
    downLoadFile(row) {
      sapDownloadFile(row.xcontent, row.filename)
    },
    // 查询客户信息
    async initCustome() {
      const params = {
        user_bp: this.role.USER_BP,
        partner: this.conditions.sold_to
      }
      const { data } = await apiSapSingleClientInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data.high_yxdy)
    },
    // 删除数据
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      if (checkedList.length === 1 && this.gridOptions.data.length === checkedList.length) {
        prodpl_item = 0
      }

      // 删除关联的销售产品行项目
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    // 保存
    async saveData(mode) {
      if (mode === 'REJECT') {
        const res = await this.$prompt('审核意见', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputValidator: value => {
            if (!value) {
              return false
            }
            return !!value.trim()
          },
          inputErrorMessage: '请输入审核意见！'
        })
        this.conditions.audit_opinion = res.value?.trim()
      }
      this.$refs['form'].validate(async(valid, err) => {
        if (valid) {
          this.errorList = []
          if (!this.gridOptions.data.length) {
            this.errorList.push('请添加生产计划项目！')
            return
          } else if (!this.gridOptions.data.every(v => v.prod_id)) {
            this.errorList.push('请选择生产计划单项目产品！')
            return
          } else if (!this.gridOptions.data.every(v => v.planqty_box)) {
            this.errorList.push('请填写生产计划单项目数量！')
            return
          } else {
            const params = {
              mode,
              user_bp: this.role.USER_BP,
              head: this.conditions,
              item: this.gridOptions.data,
              attachment: this.gridOptionsFile.data,
              history: this.gridOptionsHistory.data
            }
            let res = null

            const tip = {
              SUBMIT: '提交',
              CANCEL: '取消',
              REVOKE: '撤回'
            }

            if (Object.keys(tip).includes(mode)) {
              await this.$confirm(`确定要${tip[mode]}么`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              })
            }
            try {
              this.loading = true

              this.errorList = []
              if (mode === 'SAVE') {
                res = await apiHandleProdSave(params)
              } else if (['SUBMIT', 'APPROVE', 'REJECT'].includes(mode)) {
                res = await apiHandleProdSub(params)
              } else {
                res = await apiHandleProdRevocation(params)
              }
              if (res.msgtype !== 'S') {
                this.errorList.push(res.message)
                this.loading = false
                return
              }
              if (mode === 'SAVE') this.formDis = true
              this.$message.success(res.message)
              const { data, button } = res
              this.buttons = button
              this.gridOptions.data = data.item
              this.gridOptionsFile.data = data.attachment
              this.gridOptionsHistory.data = data.history
              Object.assign(this.conditions, data.head)
            } catch (e) {
              //
            }
            this.loading = false
          }
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    async changeInput(row) {
      this.errorList = []
      this.currentRow = row
      const params = {
        head: this.conditions,
        item: this.gridOptions.data
      }
      const { data, message, msgtype } = await apiHandleProdItem(params)
      if (msgtype === 'S') {
        Object.assign(this.conditions, data.head)
        this.gridOptions.data = data.item
      } else {
        this.gridOptions.data = data.item
        this.errorList = [message]
      }
    },
    async submitHandle() {
      if(this.dialogTitle === '组件列表'){
        this.showDialog = false
        return
      }
      if (this.dialogTitle === '客户选择') {
        const data = await this.$refs.ClientSelect.submitForm()
        const adsInfo = data.addressList.find(v => v.adr_kind === 'SHIP_TO')
        // 客户选择
        this.conditions.name_soldto = data.customerName
        this.conditions.soldto_type = data.customerType
        this.conditions.sold_to = data.customerCode
        this.conditions.bill_to = data.bill_to || data.customerCode
        this.conditions.name_billto = data.bill_to_name || data.customerName
        this.conditions.address = adsInfo?.street
        this.conditions.contactor = adsInfo.tel_number
        this.conditions.sals_center = data.high_yxdy[0]?.zzfld00001h
        this.$set(this.selectDataOptions, 'orgList', data.high_yxdy)
      } else {
        // 产品选择
        const data = await this.$refs.ProductSelect.submitForm()
        // 判断选择产品是否重复
        if (this.gridOptions.data.findIndex(v => v.prod_id === data.productCode) > -1) {
          return this.$message.warning('请勿选择重复产品！')
        }

        // delete data.remark

        // Object.assign(this.currentRow, data)
        this.currentRow.wlybrand = data.BRAND_BQ_D
        this.currentRow.prod_id = data.PRODUCT_ID
        this.currentRow.description = data.SHORT_TEXT
      }
      this.showDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      this.errorList = []
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      let adsInfo = null
      switch (type) {
        case 'customer':
          adsInfo = data.addressList.find(v => v.adr_kind === 'SHIP_TO')
          this.conditions.contactor = adsInfo.tel_number
          this.conditions.address = adsInfo?.street
          this.conditions.name_soldto = data.customerName
          this.conditions.soldto_type = data.customerType
          this.conditions.sold_to = data.customerCode
          this.conditions.bill_to = data.bill_to || data.customerCode
          this.conditions.name_billto = data.bill_to_name || data.customerName
          this.conditions.sals_center = data.high_yxdy[0]?.zzfld00001h
          this.$set(this.selectDataOptions, 'orgList', data.high_yxdy)
          break
        case 'product':
          if (row) {
            this.currentRow = row
            this.XID = row._X_ID
          }
          // 判断选择产品是否重复
          if (this.gridOptions.data.findIndex(v => v.prod_id === data.productCode && v._X_ID !== this.XID) > -1) {
            return this.$message.warning('请勿选择重复产品！')
          }
          this.currentRow.wlybrand = data.BRAND_BQ_D
          this.currentRow.prod_id = data.PRODUCT_ID
          this.currentRow.description = data.SHORT_TEXT
          break
      }
    },
    // 插入数据
    insertData() {
      prodpl_item += 10
      const data = {
        prodpl_item: prodpl_item,
        prod_id: '',
        description: '',
        planqtyBox: '',
        planqtyBottle: '',
        planqtyTon: '',
        wlybrand: '',
        area: '',
        abclv: '',
        f_date: '',
        remark: ''
      }
      this.gridOptions.data.push(data)
    },
    // 打开弹窗
    openDialog(e, title, row = undefined) {
      this.showDialog = true
      this.dialogTitle = title
      e.target.blur()
      if(title === '组件列表'){
        this.componentRowDetail = row
      }
      if (row) {
        this.currentRow = row
        this.XID = row._X_ID
      }
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          const rows = response.data.Rows.filter(item => item.value !== 'ZPD3')
          this.$set(this['selectDataOptions'], dictcode, rows)
        })
        .catch(() => {})
    },
    async uploadFile(file) {
      const _this = this
      const reader = new FileReader()
      reader.readAsArrayBuffer(file.raw)
      var strArr = []
      reader.onload = function() {
        var unitArray = new Uint8Array(this.result)
        for (var i = 0; i < unitArray.length; i++) {
          var u_arr16 = unitArray[i].toString(16).toLocaleUpperCase()
          if (u_arr16.length < 2) {
            u_arr16 = '0' + u_arr16
          }
          strArr.push(u_arr16)
        }

        strArr = strArr.join('')

        const fileData = {
          filename: file.name,
          mimetype: file.raw.type,
          doc_type: file.raw.type,
          xcontent: strArr,
          filelength: file.size,
          zzfld00002d: _this.role.USER_BP,
          zzfld00002d_dscr: _this.role.login_user,
          created_time: new Date().toLocaleTimeString().replaceAll(':', ''),
          created_date: new Date().toLocaleDateString().replaceAll('/', '')
        }

        _this.gridOptionsFile.data.unshift(fileData)
      }
    },
    parseTime(date) {
      return this.$utilsCommon.parseTime(new Date(date).getTime(), '{y}-{m}-{d}')
    },
    // 删除合同附件
    delUpload() {
      const checkedList = this.$refs.fileTable.getCheckboxRecords()

      checkedList.forEach(item => {
        const index = this.gridOptionsFile.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptionsFile.data.splice(index, 1)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-container {
  padding: 10px;
  text-align: left;
  position: relative;
  .btn-header {
    background: #fff;
    position: fixed;
    transform: translate(-10px, -10px);
    z-index: 99;
    width: calc(100% - 273px);
    height: 50px;
    padding: 5px 0 0 10px;
    box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.5);
  }
}
.blue {
    color: rgb(45, 146, 214);
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/views/make-plan-manage/hightendMakePlanOrder.vue